// import React, { useRef } from "react";
// import { FaDownload, FaShareAlt } from "react-icons/fa";
// import html2canvas from "html2canvas";
// import "./PlantationOneCertificate.scss";

// const PlantationOneCertificate = ({ userName, totalOrders }) => {
//   const certificateRef = useRef();

//   const handleDownload = async () => {
//     const element = certificateRef.current;
//     const canvas = await html2canvas(element, {
//       useCORS: true,
//       scale: 2,
//       backgroundColor: "#f8f8f2",
//     });

//     const dataUrl = canvas.toDataURL("image/png");
//     const link = document.createElement("a");
//     link.download = `Greenify-Certificate-${userName}.png`;
//     link.href = dataUrl;
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//   };

//   const handleShare = async () => {
//     try {
//       const element = certificateRef.current;
//       const canvas = await html2canvas(element, {
//         useCORS: true,
//         scale: 2,
//         backgroundColor: "#f8f8f2",
//       });

//       const dataUrl = canvas.toDataURL("image/png");
//       const blob = await (await fetch(dataUrl)).blob();
//       const filesArray = [
//         new File([blob], `Greenify-Certificate-${userName}.png`, {
//           type: "image/png",
//           lastModified: new Date().getTime(),
//         }),
//       ];

//       if (navigator.share && navigator.canShare({ files: filesArray })) {
//         await navigator.share({
//           files: filesArray,
//           title: "My Greenify Certificate",
//           text: `Check out my Greenify certificate for adopting ${totalOrders} trees!`,
//         });
//       } else {
//         handleDownload();
//       }
//     } catch (error) {
//       console.error("Error sharing:", error);
//       handleDownload();
//     }
//   };

//   return (
//     <div className="certificate-wrapper">
//       {/* Action icons OUTSIDE certificate */}
//       <div className="certificate-actions">
//         <div
//           className="action-icon"
//           onClick={handleDownload}
//           title="Download Certificate"
//         >
//           <FaDownload />
//         </div>
//         <div
//           className="action-icon"
//           onClick={handleShare}
//           title="Share Certificate"
//         >
//           <FaShareAlt />
//         </div>
//       </div>

//       {/* Certificate box */}
//       <div className="certificate-container" ref={certificateRef}>
//         {/* Decorative header with leaves */}
//         <div className="certificate-header">
//           <div className="leaf left-leaf">🌿</div>
//           <h2 className="brand-name">Greenify</h2>
//           <div className="leaf right-leaf">🌿</div>
//         </div>

//         {/* Certificate title */}
//         <div className="certificate-title">
//           <div className="title-line"></div>
//           <h1>Certificate of Adoption</h1>
//           <div className="title-line"></div>
//         </div>

//         {/* Main content */}
//         <div className="certificate-content">
//           <p className="presented-to">
//             By planting hope and nurturing life, you inspire a greener future
//             for generations to come. Through your dedication in adopting{" "}
//             {totalOrders} tree(s), you are making a lasting impact on our
//             planet.
//           </p>

//           <div className="adopter-name-container">
//             <span className="adopter-name">{userName}</span>
//           </div>

//           <div className="tree-counter">
//             <span className="tree-icon">🌳</span>
//             <span className="total-text">Total Trees Adopted:</span>
//             <span className="total-number">{totalOrders}</span>
//           </div>
//         </div>

//         {/* Footer */}
//         <div className="certificate-footer">
//           <p className="footer-date">
//             Issued on {new Date().toLocaleDateString()}
//           </p>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default PlantationOneCertificate;
import React, { useRef } from "react";
import html2canvas from "html2canvas";

const PlantAdoptionCertificate = ({
    name = "Kunika Gera",
    treesAdopted = 3, // Number of trees adopted
}) => {
    const certificateRef = useRef();

    const today = new Date().toLocaleDateString("en-GB", {
        day: "numeric",
        month: "long",
        year: "numeric",
    });

    // Download as PNG
    const downloadAsPNG = () => {
        html2canvas(certificateRef.current, { backgroundColor: null }).then((canvas) => {
            const a = document.createElement("a");
            a.download = "plant-adoption-certificate.png";
            a.href = canvas.toDataURL("image/png");
            a.click();
        });
    };

    // Share certificate as image
    const shareCertificate = () => {
        html2canvas(certificateRef.current, { backgroundColor: null }).then((canvas) => {
            canvas.toBlob((blob) => {
                const file = new File([blob], "plant-adoption-certificate.png", { type: "image/png" });
                if (navigator.canShare && navigator.canShare({ files: [file] })) {
                    navigator.share({
                        files: [file],
                        title: "My Greenify Certificate 🌱",
                        text: `I just adopted ${treesAdopted} tree(s) with Greenify! 🌿💚`,
                    });
                } else {
                    alert("Sharing is not supported on this browser.");
                }
            });
        });
    };

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column", // stack certificate and buttons
                justifyContent: "center", // center vertically
                alignItems: "center", // center horizontally
                minHeight: "100vh",
                fontFamily: "Georgia, serif",
                background: "#f5f5f5",
                gap: "20px", // space between certificate and buttons
                padding: "20px",
            }}
        >
            {/* Certificate */}
            <div
                ref={certificateRef}
                style={{
                    width: 800,
                    height: 540,
                    borderRadius: 12,
                    boxShadow: "0 6px 20px rgba(0,0,0,0.2)",
                    position: "relative",
                    backgroundImage: "url('assets/img/greenify/certificate5.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div
                    style={{
                        background: "rgba(255,255,255,0.1)",
                        borderRadius: "10px",
                        padding: "25px 35px",
                        textAlign: "center",
                        width: "80%",
                        height: "80%",
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                    }}
                >
                    {/* Logo */}
                    <img
                        src="assets/img/greenify/logo.png" // Replace with your logo path
                        alt="Greenify Logo"
                        style={{
                            width: "100px",
                            height: "100px",
                            objectFit: "contain",
                            marginBottom: "15px",
                        }}
                    />

                    <h2 style={{ color: "var(--primary-color)", margin: "5px 0", fontSize: "30px" }}>
                        Certificate of Tree Adoption
                    </h2>

                    <p
                        style={{
                            fontSize: "17px",
                            color: "#555",
                            lineHeight: 1.5,
                            margin: "15px 0 25px",
                        }}
                    >This certificate is presented in recognition of your commitment to nurturing life and fostering a greener future. Your adoption of tree(s) leaves a lasting impact on our planet.
                    </p>

                    <hr style={{ margin: "10px 0", borderColor: "#2e7d32", borderWidth: 4 }} />
                    <h2 style={{ color: "#0d5310ff", margin: "10px 0", fontSize: "40px" }}>{name}</h2>
                    <hr style={{ margin: "10px 0", borderColor: "#2e7d32", borderWidth: 4 }} />

                    <p style={{ fontSize: "16px", color: "#444", marginTop: 10 }}>
                        🌱 Number of Trees Adopted: {treesAdopted}
                    </p>

                    <p style={{ fontSize: "12px", color: "#444", marginTop: 15 }}>Issued on {today}</p>
                    <p style={{
                        fontSize: "14px",
                        color: "#2e7d32",
                        marginTop: 15
                    }}>
                        Visit us at: <a
                            href="https://www.greenify.com"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: "#2e7d32", textDecoration: "underline" }}
                        >
                            www.greenify.com
                        </a>
                    </p>

                </div>
            </div>

            {/* Buttons */}
            <div style={{ textAlign: "center" }}>
                <button
                    onClick={downloadAsPNG}
                    style={{
                        marginRight: 10,
                        padding: "10px 25px",
                        fontSize: "0.9rem",
                        background: "#2e7d32",
                        color: "#fff",
                        border: "none",
                        borderRadius: "6px",
                        cursor: "pointer",
                        boxShadow: "0 3px 6px rgba(0,0,0,0.2)",
                    }}
                >
                    ⬇️ Download
                </button>
                <button
                    onClick={shareCertificate}
                    style={{
                        padding: "10px 25px",
                        fontSize: "0.9rem",
                        background: "#388e3c",
                        color: "#fff",
                        border: "none",
                        borderRadius: "6px",
                        cursor: "pointer",
                        boxShadow: "0 3px 6px rgba(0,0,0,0.2)",
                    }}
                >
                    📤 Share
                </button>
            </div>
        </div>
    );
};

export default PlantAdoptionCertificate;
